import { Component, OnInit } from '@angular/core';
import { Item } from '../../../core/components/listbox/listbox.component';
import { DataTaskService } from '../../../core/services/data-task.service';

@Component({
  selector: 'tt-edi-sources',
  templateUrl: './edi-sources.component.html',
  styleUrls: ['./edi-sources.component.css']
})
export class EdiSourcesComponent implements OnInit {
    public itemsListEdiSources: Item[] = [];

    constructor(private datatask: DataTaskService) {

    }

    private async loadEdiSources() {
        this.itemsListEdiSources = await this.datatask.Post(978);
    }

    private async init() {
        this.loadEdiSources();
    }

    ngOnInit() {
        this.init();
    }
}
